// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-K":"K_vanlife-roadtrips-K__LDC8B"};